import { SimpleGrid, useBreakpointValue } from '@hover/blueprint';
import { iArrowLeft } from '@hover/icons';
import React, { useEffect } from 'react';

import { CardHeader } from 'src/modules/designStudio/components/DesignMenu/CardHeader';
import { TestPageIds } from 'src/modules/designStudio/components/DesignMenu/ProductCatalogMenu/ProductSearch/TestIds';
import { GroupCard } from 'src/modules/designStudio/components/DesignMenu/ProductCatalogMenu/WallMenu/GroupCard';
import { VariationGroupCard } from 'src/modules/designStudio/components/DesignMenu/ProductCatalogMenu/WallMenu/VariationGroupCard';
import { ScrollMenu } from 'src/modules/designStudio/components/DesignMenu/ScrollMenu';
import type { MaterialGroup } from 'src/modules/designStudio/helpers/productSelection/types';
import { useIsLandscape } from 'src/shared/hooks';

export type MaterialGroupsMenuProps = {
  onBack: () => void;
  onPrimaryClick: (group: MaterialGroup) => void;
  onSecondaryClick: (group: MaterialGroup) => void;
  materialGroups: MaterialGroup[];
};

export const MaterialGroups = ({
  onBack,
  onPrimaryClick,
  onSecondaryClick,
  materialGroups,
}: MaterialGroupsMenuProps) => {
  useEffect(() => {
    if (materialGroups.length === 1) {
      onPrimaryClick(materialGroups[0]);
    }
  }, [materialGroups, onPrimaryClick]);

  const [isLandscape] = useIsLandscape();
  const mobileColumns = useBreakpointValue({ base: 2, width250: 4 });

  return (
    <ScrollMenu.Menu data-testid={TestPageIds.SHOW_WALL_GROUPS}>
      <ScrollMenu.Header>
        <CardHeader
          headerText="Walls"
          leftActionHandler={onBack}
          leftIcon={iArrowLeft}
          leftIconId="Back"
          m={0}
        />
      </ScrollMenu.Header>
      <ScrollMenu.Body>
        <SimpleGrid
          columns={isLandscape ? 2 : mobileColumns}
          display="grid"
          flexShrink={1}
          gap={400}
        >
          {materialGroups.map(group =>
            group.variation ? (
              <VariationGroupCard
                group={group}
                key={group.variation.uuid}
                onPrimaryClick={() => {
                  onPrimaryClick(group);
                }}
                onSecondaryClick={() => {
                  onSecondaryClick(group);
                }}
              />
            ) : (
              <GroupCard
                groupAppearance={group.appearance}
                key={group.appearance.textureId}
                onSelected={() => {
                  onPrimaryClick(group);
                }}
              />
            ),
          )}
        </SimpleGrid>
      </ScrollMenu.Body>
    </ScrollMenu.Menu>
  );
};
